<template>
    <div class="competition_wrap">
        <div class="banner">
            <div class="banner_content">
                <div class="banner_title">MaxSwell&nbsp;竞赛与任务平台</div>
                <div class="banner_text">数据平台上资源丰富，环境配置齐全，通过竞赛与任务驱动,结合教学与科研实际需要，双向激发学习与科研的兴趣.</div>
            </div>
        </div>
        <div class="compet_content">
            <div class="compet_list">
                <div class="competition_tips" v-if="competitionList.length === 0">
                    当前暂无竞赛信息
                </div>

                <div class="competition_item"
                     @click="enterCompete(item.competitionId)"
                     :class="competitionImgClassList[item.status]"
                     v-if="competitionList.length > 0"
                     v-for="item in competitionList" :key="item.id">
                    <div class="competition_item_content">
                        <div class="item_title single_line_abbreviated">{{ item.competitionName }}</div>
                        <div class="item_introduce">比赛日期</div>
                        <div class="item_time">{{ item.startTime }} - {{ item.endTime }}</div>
                    </div>
                </div>
                <div class="compet_item_surplus" v-for="i in surplusCount" :key="'index'+i"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {getCompetitionList} from "@/utils/api";

export default {
    data() {
        return {
            classData: '',
            surplusCount: '',
            hoverId: 1,
            competitionList: [],
            competitionImgClassList: [
                'signed',
                'signable',
                'not_sign'
            ]
        }
    },
    created() {
        //初始化当前用户的竞赛报名情况
        this.getCompetitionList();
    },
    methods: {
        enterCompete(competitionId) {
            this.$router.push({path: '/competeDetail', query: {competitionId: competitionId}})
        },
        getCompetitionList() {
            getCompetitionList().then(res => {
                this.competitionList = res.data;
                this.ensureFlexLayout();
            });
        },
        ensureFlexLayout() {
            //设置弹性布局的行数
            this.surplusCount = this.$core.setSurplusCount(this.competitionList.length, 3)
        },
    }
}
</script>
<style lang="scss" scoped>
.compet_content {
    box-sizing: border-box;
    padding: 30px 60px;
    width: 100%;
    margin-bottom: 50px;

    .compet_list {
        width: 100%;
        padding: 30px;
        background: #FAFBFF;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;
        align-items: flex-start;
        transition: .5s ease-in-out;

        .competition_tips {
            font-size: 18px;
            text-align: center;
            width: 100%;
            color: gray;
        }

        .compet_item_surplus {
            box-sizing: border-box;
            padding: 20px 15px;
            width: 33%;
            height: 200px;
        }

        .competition_item {
            box-sizing: border-box;
            width: 32.8%;
            height: 200px;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: cover;
            transition: .3s ease-in-out;
            display: flex;
            justify-content: right;
            margin-bottom: 15px;
            background-color: white;

            .competition_item_content {
                width: 54%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .item_title {
                    font-size: 24px;
                    color: #333333;
                    font-weight: bold;
                    line-height: 31px;
                    width: 100%;
                    margin-bottom: 35px;
                    text-align: left;
                }

                .item_introduce {
                    font-size: 16px;
                    color: #333333;
                    width: 100%;
                    text-align: left;
                    line-height: 24px;
                }

                .item_time {
                    font-size: 15px;
                    color: #333333;
                    line-height: 21px;
                    width: 100%;
                    text-align: left;
                }
            }

            &:hover {
                cursor: pointer;
                filter: brightness(0.97);
                box-shadow: 0 0 10px 0 #CCCCCC;
            }
        }

        .signed {
            background-image: url("../../../assets/img/signed.png");
        }

        .signable {
            background-image: url("../../../assets/img/signable.png");
        }

        .not_sign {
            background-image: url("../../../assets/img/not_sign.png");
        }
    }
}

.competition_wrap {
    // height: calc(100vh - 60px);
    .banner {
        height: 630px;
        width: 100%;
        background: url(../../../assets/img/compet_banner.png) 0 0/100% 100% no-repeat;

        .banner_content {
            position: relative;
            top: 220px;
            left: 130px;
            color: #5277F7;

            .banner_title {
                font-size: 50px;
                letter-spacing: 1px;
                margin-bottom: 40px;
                font-weight: bold;
            }

            .banner_text {
                width: 40%;
                line-height: 1.8;
                font-size: 23px;
                letter-spacing: 1px;
            }
        }
    }
}
</style>